export const IMAGES = {
    surgeon:
        "https://images.unsplash.com/photo-1571772996211-2f02c9727629?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwZG9jdG9yJTIwaGVhbHRoY2FyZSUyMGxhYm9yYXRvcnklMjBzdXJnaWNhbHxlbnwwfHx8fDE3OTE2OTI1NzB8MA&ixlib=rb-4.1.0&q=85",
    physician:
        "https://images.unsplash.com/photo-1536064479547-7ee40b74b807?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwZG9jdG9yJTIwaGVhbHRoY2FyZSUyMGxhYm9yYXRvcnklMjBzdXJnaWNhbHxlbnwwfHx8fDE3OTE2OTI1NzB8MA&ixlib=rb-4.1.0&q=85",
    researcher:
        "https://images.unsplash.com/photo-1569830904560-2afd7062213c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwZG9jdG9yJTIwaGVhbHRoY2FyZSUyMGxhYm9yYXRvcnklMjBzdXJnaWNhbHxlbnwwfHx8fDE3OTE2OTI1NzB8MA&ixlib=rb-4.1.0&q=85",
    diagnostic:
        "https://images.unsplash.com/photo-1639945314222-60223e6cd32b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob3NwaXRhbCUyMGRvY3RvciUyMG1lZGljYWwlMjB0ZWNobm9sb2d5JTIwYWZyaWNhfGVufDB8fHx8MTc5MTY5MjU2M3ww&ixlib=rb-4.1.0&q=85",
    founder:
        "https://images.unsplash.com/photo-1683107983270-38225df18859?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwc3RhcnR1cCUyMHRlYW0lMjBvZmZpY2UlMjBhZnJpY2ElMjBtZWV0aW5nfGVufDB8fHx8MTc5MTY5MjU3MHww&ixlib=rb-4.1.0&q=85",
    rally:
        "https://images.unsplash.com/photo-1750090669027-70ac8063d5a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwcG9saXRpY2FsJTIwY2FtcGFpZ24lMjBzcGVlY2glMjByYWxseSUyMGxlYWRlcnxlbnwwfHx8fDE3OTE2OTI1NzB8MA&ixlib=rb-4.1.0&q=85",
    civic:
        "https://images.unsplash.com/photo-1593055474325-35b16a1330f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxhZnJpY2FuJTIwcG9saXRpY2FsJTIwY2FtcGFpZ24lMjBzcGVlY2glMjByYWxseSUyMGxlYWRlcnxlbnwwfHx8fDE3OTE2OTI1NzB8MA&ixlib=rb-4.1.0&q=85",
    studentsLab:
        "https://images.unsplash.com/photo-1719159381981-1327b22aff9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHxfHxhZnJpY2FuJTIwdW5pdmVyc2l0eSUyMHN0dWRlbnRzJTIwY2FtcHVzJTIwY2xhc3Nyb29tJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3OTE2OTMxNTF8MA&ixlib=rb-4.1.0&q=85",
    studentLearn:
        "https://images.unsplash.com/photo-1541178735493-479c1a27ed24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwdW5pdmVyc2l0eSUyMHN0dWRlbnRzJTIwY2FtcHVzJTIwY2xhc3Nyb29tJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3OTE2OTMxNTF8MA&ixlib=rb-4.1.0&q=85",
    campus:
        "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlJTIwY2xhc3Nyb29tJTIwZS1sZWFybmluZ3xlbnwwfHx8fDE3OTE2OTMxNTV8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICE_LABELS = {
    "health-system": "Health system",
    institution: "School / university",
    startup: "Startup / new business",
    "political-campaign": "Political campaign",
    other: "Something else",
};

export const PRACTICE_META = {
    health: { serviceKey: "health-system" },
    institutions: { serviceKey: "institution" },
    startups: { serviceKey: "startup" },
    campaigns: { serviceKey: "political-campaign" },
};

export const PROJECTS = [
    {
        id: "afyalink",
        title: "AfyaLink County Portal",
        category: "health",
        image: IMAGES.physician,
        description: "Patient portal, HMIS integration and appointment orchestration for a county referral network.",
        descriptionSw: "Mlango wa wagonjwa, uunganishaji wa HMIS na uratibu wa miadi kwa mtandao wa rufaa wa kaunti.",
        metric: "38 facilities · 210k patient records",
        metricSw: "vituo 38 · kumbukumbu 210k za wagonjwa",
    },
    {
        id: "tibatele",
        title: "TibaTele",
        category: "health",
        image: IMAGES.diagnostic,
        description: "Telemedicine platform connecting rural clinics to specialist consultants in real time.",
        descriptionSw: "Jukwaa la telemedisini linalounganisha kliniki za vijijini na wataalamu kwa wakati halisi.",
        metric: "12k consultations in year one",
        metricSw: "mashauriano 12k mwaka wa kwanza",
    },
    {
        id: "mamacare",
        title: "MamaCare Clinics",
        category: "health",
        image: IMAGES.surgeon,
        description: "Website, online booking and antenatal reminder flows for a maternal health clinic chain.",
        descriptionSw: "Tovuti, uhifadhi mtandaoni na ukumbushaji wa ujauzito kwa mnyororo wa kliniki za afya ya mama.",
        metric: "3x more bookings in 90 days",
        metricSw: "miadi mara 3 zaidi ndani ya siku 90",
    },
    {
        id: "elimika",
        title: "Elimika Schools Network",
        category: "institution",
        image: IMAGES.studentsLab,
        description: "Unified websites, parent portals and fee tracking for a network of 14 secondary schools.",
        descriptionSw: "Tovuti zilizounganishwa, milango ya wazazi na ufuatiliaji wa ada kwa mtandao wa shule 14 za sekondari.",
        metric: "14 schools · 9,800 guardians onboarded",
        metricSw: "shule 14 · wazazi 9,800 wamejiunga",
    },
    {
        id: "chuolink",
        title: "ChuoLink University",
        category: "institution",
        image: IMAGES.campus,
        description: "Admissions funnel, e-learning gateway and alumni platform for a private university.",
        descriptionSw: "Mfereji wa udahili, lango la e-elimu na jukwaa la wanazuoni kwa chuo kikuu binafsi.",
        metric: "41% rise in completed applications",
        metricSw: "ongezeko la 41% la maombi yaliyokamilika",
    },
    {
        id: "jengapay",
        title: "JengaPay",
        category: "startup",
        image: IMAGES.founder,
        description: "Brand, marketing site and MVP web app for an SME payments startup — launch to first users in 8 weeks.",
        descriptionSw: "Chapa, tovuti ya masoko na programu ya MVP kwa biashara mpya ya malipo — uzinduzi hadi watumiaji wa kwanza kwa wiki 8.",
        metric: "Seed-ready in 8 weeks",
        metricSw: "tayari kwa wawekezaji kwa wiki 8",
    },
    {
        id: "sauti-yetu",
        title: "Sauti Yetu 2027",
        category: "campaign",
        image: IMAGES.rally,
        description: "Gubernatorial campaign platform: manifesto site, donation funnel and volunteer CRM.",
        descriptionSw: "Jukwaa la kampeni ya ugavana: tovuti ya ilani, mfereji wa michango na CRM ya wajitoleaji.",
        metric: "62k volunteers registered",
        metricSw: "wajitoleaji 62k wameandikishwa",
    },
    {
        id: "umoja-rising",
        title: "Umoja Rising",
        category: "campaign",
        image: IMAGES.civic,
        description: "Civic movement platform with constituency mapping and SMS-integrated mobilisation.",
        descriptionSw: "Jukwaa la harakati za kiraia lenye ramani za majimbo na uhamasishaji uliounganishwa na SMS.",
        metric: "47 constituencies covered",
        metricSw: "majimbo 47 yamefikiwa",
    },
];
